export default [
    {
        path: 'subscriptions',
        component: require('@/layouts/content/subscriptions').default,
        name: 'admin.subscriptions',
        redirect: to => {
            return {
                name: 'admin.subscriptions.index'
            }
        },
        children: [
            /** Products */
            {
                path: '/',
                name: 'admin.subscriptions.index',
                component: require('@/views/admin/products/subscriptions/index').default,
                meta: {
                    auth: {
                        roles: ['manage-products']
                    }
                }
            },
            {
                path: 'create',
                name: 'admin.subscriptions.create',
                component: require('@/views/admin/products/subscriptions/form').default,
                meta: {
                    mode: 'create',
                    auth: {
                        roles: ['manage-products']
                    }
                }
            },
            {
                path: ':id',
                name: 'admin.subscriptions.edit',
                component: require('@/views/admin/products/subscriptions/form').default,
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-products']
                    }
                }
            },
        ]
    }
]